export default __webpack_public_path__ + "static/media/img7.19ea5b6d.png";